import baseUrl from "../config/baseUrl";

const combineDocuments = async ({ token, document_ids, doc_type }) => {
  try {
    // Map doc type to API action
    const ACTION_BY_TYPE = {
      pdf: "combine-documents",
      word: "combine-word-docs",
      images: "combine-images",
    };

    const action = ACTION_BY_TYPE[doc_type]; // ✅ now declared
    if (!action) {
      return false;
    }

    const response = await fetch(`${baseUrl}/api/${action}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // required
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ document_ids }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API fetch error:", error);
    return error;
  }
};

export default combineDocuments;
